import { Add } from '@brandfolder/icons';
import { BrandfolderHexColors } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';

const AddCustomRoleCardWrapper = styled.button`
  border: 2px dashed ${BrandfolderHexColors.GrayBorder};
  border-radius: 4px;
  padding: 44px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: transparent;
  width: 100%;
  height: 100%;

  &:hover {
    background-color: ${BrandfolderHexColors.DirtyMarshmallow};
  }

  &:focus {
    outline: 1px solid ${BrandfolderHexColors.PurplePopsicle};
    outline-offset: 2px;
  }
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 450;
  color: ${BrandfolderHexColors.PurplePopsicle};
  margin: 0;
`;

const AddIcon = styled(Add)`
  path {
    fill: ${BrandfolderHexColors.PurplePopsicle};
  }
`;

interface AddCustomRoleCardProps {
  onNavigateToCreate?: () => void;
}

export const AddCustomRoleCard: FunctionComponent<AddCustomRoleCardProps> = ({ onNavigateToCreate }) => {

  const handleClick = (): void => {
    if (onNavigateToCreate) {
      onNavigateToCreate();
    }
  };

  return (
    <I18nProviderWrapper>
      <AddCustomRoleCardWrapper onClick={handleClick}>
        <AddIcon height={32} viewBox='0 0 16 16' width={32} />
        <CardTitle><Trans>Add custom role</Trans></CardTitle>
      </AddCustomRoleCardWrapper>
    </I18nProviderWrapper>
  );
};
